var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgCircleDiscount = function SvgCircleDiscount(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "currentColor"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10.452 13.117c.005 1.198.77 2.216 2.197 2.216 1.412 0 2.201-1.018 2.196-2.216v-.526c.005-1.208-.764-2.216-2.196-2.216-1.408 0-2.192 1.018-2.197 2.216v.526ZM5.333 7.41c.005 1.198.77 2.206 2.192 2.206 1.417 0 2.206-.998 2.201-2.206v-.526c.005-1.208-.764-2.216-2.201-2.216-1.393 0-2.187 1.008-2.192 2.216v.526Zm.156 7.924H6.76l7.6-10.666H13.09l-7.6 10.666Zm6.38-2.742c.005-.477.195-.969.78-.969.613 0 .774.492.77.97v.525c.004.478-.176.96-.77.96-.594 0-.775-.497-.78-.96v-.526ZM6.76 6.883c.005-.463.185-.97.765-.97.613 0 .78.493.774.97v.526c.005.477-.18.96-.774.96-.575 0-.76-.483-.765-.96v-.526Z",
    fill: "white"
  })));
};
export default SvgCircleDiscount;